/** Customer survey URL used for ambassador QR codes in admin. */
export function buildStaffSurveyQrUrl(staffCode: string | null | undefined): string {
  if (!staffCode?.trim()) return '';

  const fromEnv = import.meta.env.VITE_SURVEY_FRONTEND_URL;
  const base =
    typeof fromEnv === 'string' && fromEnv.trim()
      ? fromEnv.trim().replace(/\/$/, '')
      : typeof window !== 'undefined'
        ? window.location.origin.replace(/:\d+$/, ':5174')
        : '';

  if (!base) return '';
  return `${base}/?ref=${encodeURIComponent(staffCode.trim())}`;
}
